import { createContainer, defer } from '@dbk-legacy/muster/react';

import AssetPositionsDetails from './asset-position-details';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

export const defaultRowFragment = {
  secID: true,
  name: true,
  number: true,
  index: true,
  id: true,
  isin: true,
  currency: true,
  lastPrice: true,
  dayChange: true,
  dayChangePercentage: true,
  averagePurchasePrice: true,
  priceDate: true,
  unrealisedGLPositionCurrency: true,
  quantity: true,
  marketValue: true,
  unrealisedGL: true,
  proportion: true,
  asOfDate: true,
  assetShortDesc: true,
  assetGroupId: true,
  // priceHistory: true,
  availableBalance: true,
  accruedInterest: true,
  balance: true,
  depositeAmount: true,
  rating: true,
  maturityDate: true,
  subAssetsDesc: true,
  ricCode: true,
  restricted: true,
  enabled: true,
  tradable: true,
  // valueMovement:true
  // priceHistory: {
  //   $type: 'list',
  //   // TODO ref
  //   // $range: { offset: 0, length: ref('priceHistory.length') },
  //   $range: { from: 0, to: 4 },
  //   $node: defer({
  //     price: true,
  //     date: true,
  //   }),
  // },
};

export function defaultRowMapper({
  lastPrice,
  currency,
  ...rest,
}) {
  return {
    lastPrice,
    positionCurrency: currency,
    lastPriceUnit: currency,
    chartHeaderValue: lastPrice,
    chartHeaderValueUnit: currency,
    averagePurchasePriceUnit: currency,
    unrealisedGLPositionCurrencyUnit: currency,
    ...rest,
  };
}

export function factory({
  rowFragment = defaultRowFragment,
  rowFragmentExtend,
  rowFragmentOmit,
  mapper = defaultRowMapper,
  mapperExtend,
  omitRowFields,
  component = AssetPositionsDetails,
} = {}) {
  let resultingRowFragment = rowFragment;

  if (rowFragmentExtend) {
    resultingRowFragment = merge({}, rowFragment, rowFragmentExtend);
  }

  let resultingRowMapper = mapper;

  if (mapperExtend) {
    resultingRowMapper = row => merge(
      {},
      mapper(row),
      mapperExtend(row),
    );
  }

  if (rowFragmentOmit) {
    resultingRowFragment = omit(resultingRowFragment, rowFragmentOmit);
  }

  return createContainer({
    $fragments: {
      uiStatic: {
        options: true,
        detailsGroups: true,
      },
      row: resultingRowFragment,
    },
    $queries: {
      moveToTransactionPage: { $call: 'ui.positions.currentPosition.transactions.moveToTransaction' },
      changePage: { $call: 'ui.history.push' },
    },
  }, ({ uiStatic, row, changePage, moveToTransactionPage }) => {
    let resultingRow = resultingRowMapper(row);

    if (omitRowFields) {
      resultingRow = omit(resultingRow, resultingRow);
    }

    return {
      detailsGroups: uiStatic.detailsGroups,
      headerGroup: uiStatic.options,
      row: resultingRow,
      changePage,
      moveToTransactionPage
    };
  })(component);
}

export default factory();
